// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-overlay[data-v-048d1028]{position:fixed;display:flex;overflow:auto;align-items:stretch;justify-content:center;top:0;bottom:0;left:0;right:0;background-color:rgba(15,35,69,.5);z-index:100}.content-wrap[data-v-048d1028]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
